import React from 'react'
import RangeTouch from 'rangetouch'

import './Slider.scss'

class Slider extends React.Component {
  handleChange(e) {
    this.props.onChange(parseInt(e.currentTarget.value, 10))
  }
  componentDidMount() {
    new RangeTouch('[type=range]')
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.value === this.props.value ? false : true
  }
  render() {
    const range = this.props.max - this.props.min
    const dots = new Array(range + 1).fill(null)
    const relativeValue = this.props.value - this.props.min
    const pos = (relativeValue / range) * 100
    const barStyle = {
      left: Math.min(pos, 50) + '%',
      right: 100 - Math.max(pos, 50) + '%',
    }
    return (
      <div className="cond-group">
        <label className="slider-control">
          <input
            type="range"
            min={this.props.min}
            max={this.props.max}
            value={this.props.value}
            step="1"
            onInput={e => this.handleChange(e)}
            onChange={e => this.handleChange(e)}
          />
          <div className="bar-wrapper">
            <div className="bar" style={barStyle} />
          </div>
          <div className="dots">
            {dots.map((d, i) => {
              const dotStyle = {
                left: (100 / range) * i + '%',
              }
              return <span style={dotStyle} className="dot" key={i} />
            })}
          </div>
          <span className="label min">{this.props.label.min}</span>
          <span className="label max">{this.props.label.max}</span>
        </label>
      </div>
    )
  }
}

export default Slider
